<template>
  <b-card :title="producer.display_name" style="margin-left:.5cm; margin-bottom:.5cm;">
    <b-card-text>
      <p v-for="stream in producer.streams" class="stream-row" v-bind:key="stream.id">
        <b-button class="feed-button btn-outline-danger" @click="feedPlayer(stream)" variant="outline-primary" :disabled="stream.status=='CREATING' || stream.status == 'CREATED'">{{calc_stream_name(stream.feed_name)}}</b-button>&nbsp;
        <b v-if="stream.is_live" style="color:red">
          LIVE
          <b-spinner
                  style="margin-bottom: 2px;"
                  small
                  variant="danger"
                  type="grow"
                  label="Spinning"
          ></b-spinner>
        </b>
      </p>
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  name: "Producer",
  props: {
    producer: Object
  },
  methods: {
    feedPlayer(stream) {
      this.$emit("feedPlayer", stream);
    },
    calc_stream_name(stream_name) {
      var name = stream_name.split(' (With overlays)')[0]
      if (name == "Program Feed"){
        return "Tactical Camera"
      } else if (name == "Clean Feed"){
        return "Demo Multicam"
      } else {
        return name
      }
    }
  }
};
</script>